export default __webpack_public_path__ + "static/media/clearp05.cc39e466.png";